import { environment } from '@environments/environment';

export const GET_FURNITURES_IMAGE_NAME_QUERY = (langcode: string, productType: string, filters?: string[]) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              type_produit: productType,
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          ...(filters && filters?.length > 0 ? [{ terms: { field_furniture_category: filters } }] : []),
        ],
      },
    },
    _source: ['title', 'field_images'],
  },
});
